/**
 * 查新任务步骤
 */
export enum NoveltyCheckTaskStep {
    /**
     * 初始状态, 新任务
     * @description 任务初始状态，任务没有创建，任务在服务端没有记录【**客户端状态**】。
     * * 下一个状态（步骤）是 {@link NoveltyCheckTaskStep.SUMMARY} 或 {@link NoveltyCheckTaskStep.NOVELTY_SEARCH_TECH_FEATURE}
     */
    INITIAL = '',
    /**
     * 总结用户输入为技术要点状态（步骤）
     * @description 这是一个【**客户端状态**】. 处于 {@link NoveltyCheckTaskStep.INITIAL} 状态时，任务创建成功后，如果用户输入字符长度超过 2000 字符，则进入这个状态（步骤）。
     * 这个状态（步骤）展示 summary loading 过程, summary 拉取成功后，会自动进入下一步状态。
     * * 上一个状态（步骤）是 {@link NoveltyCheckTaskStep.INITIAL}
     * * 下一个状态（步骤）是 {@link NoveltyCheckTaskStep.NOVELTY_SEARCH_TECH_FEATURE}
     */
    SUMMARY = 'SUMMARY',
    /**
     * 任务已经提交，但未成功提取特征状态（步骤）
     * @description 手动修改技术要点
     * 此状态主要通过用户手动操作进入，用于编辑技术要点。
     * * 上一个状态（步骤）是 {@link NoveltyCheckTaskStep.NOVELTY_SEARCH_TECH_FEATURE}（通过 handlePrevious）
     * * 下一个状态（步骤）是 {@link NoveltyCheckTaskStep.NOVELTY_SEARCH_TECH_FEATURE}
     */
    NOVELTY_SEARCH_INPUT = 'NOVELTY_SEARCH_INPUT',
    /**
     * 技术特征识别状态（步骤）
     * * 上一个状态（步骤）是 {@link NoveltyCheckTaskStep.SUMMARY} 或 {@link NoveltyCheckTaskStep.NOVELTY_SEARCH_INPUT}
     *     * 处于 {@link NoveltyCheckTaskStep.INITIAL} 状态时，任务创建成功后，如果用户输入字符长度没有超过 2000 字符，则进入这个状态（步骤）
     *     * 处于 {@link NoveltyCheckTaskStep.SUMMARY} 状态时，用户点击【下一步】按钮后，会进入这个状态（步骤）
     *     * 处于 {@link NoveltyCheckTaskStep.NOVELTY_SEARCH_INPUT} 状态时，用户点击【下一步】按钮后，也会进入这个状态（步骤）
     * * 下一个状态（步骤）是 {@link NoveltyCheckTaskStep.NOVELTY_SEARCH_RETRIEVAL_ELEMENTS}
     *     * 如果特征提取成功，会自动进入下一步状态
     *     * 如果特征提取失败，会保持在当前状态，等待用户操作
     */
    NOVELTY_SEARCH_TECH_FEATURE = 'NOVELTY_SEARCH_TECH_FEATURE',
    /**
     * 检索要素识别结束状态（步骤）
     * @description 检索要素识别结束，达到的状态（步骤）
     * * 上一个状态（步骤）是 {@link NoveltyCheckTaskStep.NOVELTY_SEARCH_TECH_FEATURE}
     * * 下一个状态（步骤）是 {@link NoveltyCheckTaskStep.SEARCH_FINISHED}
     */
    NOVELTY_SEARCH_RETRIEVAL_ELEMENTS = 'NOVELTY_SEARCH_RETRIEVAL_ELEMENTS',
    /**
     * 检索完成状态（步骤）
     * @description 检索完成，达到的状态（步骤）
     * * 上一个状态（步骤）是 {@link NoveltyCheckTaskStep.PATENT_CONFIRM}
     * * 下一个状态（步骤）是 {@link NoveltyCheckTaskStep.REPORT_CREATED}
     */
    SEARCH_FINISHED = 'CONFIRM',
    /**
     * 专利确认状态,专利初筛（步骤）
     * @description 专利确认，达到的状态（步骤）
     * * 上一个状态（步骤）是 {@link NoveltyCheckTaskStep.NOVELTY_SEARCH_RETRIEVAL_ELEMENTS}
     * * 下一个状态（步骤）是 {@link NoveltyCheckTaskStep.SEARCH_FINISHED}
     */
    PATENT_CONFIRM = 'PATENT_CONFIRM',
    /**
     * 生成特征对比表
     * @description 生成特征对比表，达到的状态（步骤）
     * * 上一个状态（步骤）是 {@link NoveltyCheckTaskStep.PATENT_CONFIRM}
     * * 下一个状态（步骤）是 {@link NoveltyCheckTaskStep.REPORT_CREATED}
     */
    GENERATE_FEATURE_COMPARE_TABLE = 'GENERATE_FEATURE_COMPARE_TABLE',
    /**
     * 报告生成结束
     * @description 报告生成成功后，达到的状态（步骤）
     * * 上一个状态（步骤）是 {@link NoveltyCheckTaskStep.GENERATE_FEATURE_COMPARE_TABLE}
     */
    REPORT_CREATED = 'RESULT',
}
